import {
  Autocomplete,
  Box,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Button } from "@mui/material";
import { Field } from "formik";
import React, { useEffect, useState } from "react";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Save as SaveIcon,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import PaymentDetails from "./PaymentDetails";
import DeletedIncomeDetails from "./DeletedIncomeDetails";
import { bookingApi } from "../apiService";
import DeletedPayments from "./DeletedPayments";
import { calculateAmount } from "../utils/calculateAmounts";
import { otherIncomeTypes } from "../../../constants";
import { commonTextFieldProps, smallButtonProp } from "../../../utils/styles";

const OtherIncomes = ({
  income,
  index,
  values,
  setFieldValue,
  setIncomeSummary,
  setAdditionalFields,
  formatCurrency,
  remove,
  calculateIncomeSummary,
  errors,
  gstPercentage,
}: any) => {
  const [isEditMode, setIsEditMode] = useState(false);
  useEffect(() => {
    setFieldValue(`incomes.${index}.gstPercentage`, gstPercentage);
  }, [gstPercentage]);

  const checkDisabled = () => {
    if (!income?.id) return false;
    return !isEditMode;
  };

  return (
    <>
      {!["perkm", "fixed"].includes(income?.incomeType) && (
        <>
          <Grid container spacing={1} key={index}>
            <Grid item xs={12} md={3}>
              <Autocomplete
                freeSolo
                options={otherIncomeTypes}
                value={income?.incomeType}
                onChange={(_, newValue) =>
                  setFieldValue(`incomes.${index}.incomeType`, newValue || "")
                }
                onInputChange={(_, newInputValue) =>
                  setFieldValue(`incomes.${index}.incomeType`, newInputValue)
                }
                disabled={checkDisabled()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Income Type"
                    placeholder="Enter income type"
                    required
                    InputProps={{
                      ...params.InputProps,
                    }}
                    {...commonTextFieldProps}
                    disabled={checkDisabled()}
                    error={Boolean(errors?.incomes?.[index]?.incomeType)}
                    helperText={errors?.incomes?.[index]?.incomeType}
                  />
                )}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: "0.75rem" }}
                    >
                      {option}
                    </Typography>
                  </Box>
                )}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Field
                as={TextField}
                fullWidth
                label="Amount (₹)"
                name={`incomes.${index}.amount`}
                value={
                  values?.incomes?.[index]?.amount &&
                  values?.incomes?.[index]?.amount >= 0
                    ? Number(values?.incomes?.[index]?.amount).toLocaleString(
                        "en-IN"
                      )
                    : ""
                }
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const cleanValue = e.target.value.replace(/[^0-9]/g, "");
                  setFieldValue(`incomes.${index}.amount`, cleanValue);
                  setFieldValue(`incomes.${index}.isEdited`, true);
                }}
                onBlur={() => {
                  calculateAmount(values?.incomes, setAdditionalFields);
                  values?.incomes?.length > 0 &&
                    calculateIncomeSummary(values?.incomes, setIncomeSummary);
                }}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">₹</InputAdornment>
                  ),
                }}
                required
                {...commonTextFieldProps}
                disabled={checkDisabled()}
                error={Boolean(errors?.incomes?.[index]?.amount)}
                helperText={errors?.incomes?.[index]?.amount}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Field
                as={TextField}
                fullWidth
                label="Remarks"
                name={`incomes.${index}.remarks`}
                {...commonTextFieldProps}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue(`incomes.${index}.remarks`, e.target.value);
                  setFieldValue(`incomes.${index}.isEdited`, true);
                }}
                disabled={checkDisabled()}
              />
            </Grid>
            {!income?.id && (
              <Grid item xs={12} md={2}>
                <IconButton
                  color="error"
                  onClick={() => {
                    // Create a local copy of incomes without the current index
                    const updatedIncomes =
                      values?.incomes?.filter(
                        (_: any, i: number) => i !== index
                      ) || [];
                    remove(index);
                    // Use the updated local copy for calculation
                    if (updatedIncomes.length > 0) {
                      calculateIncomeSummary(updatedIncomes, setIncomeSummary);
                    }
                  }}
                >
                  <DeleteIcon sx={{ width: "16px", height: "16px" }} />
                </IconButton>
              </Grid>
            )}
            <Grid
              item
              md={2}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              {!isEditMode && income?.id && (
                <Button
                  size="small"
                  sx={{
                    height: "20px",
                    width: "50px",
                    fontSize: "0.6rem",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setIsEditMode(true);
                  }}
                >
                  Edit
                </Button>
              )}
              {isEditMode && income?.id && (
                <Button
                  size="small"
                  sx={{
                    height: "20px",
                    width: "50px",
                    fontSize: "0.6rem",
                  }}
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setIsEditMode(false);
                  }}
                >
                  Cancel
                </Button>
              )}
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
        </>
      )}
    </>
  );
};

export default OtherIncomes;
